const state = {
    medienitems: 0
}

const getters = {
    medienitems: state => state.medienitems
}

const actions = {
    updatemedienItem ({ commit }, qty) {
        commit('updatemedienItem', qty)
    }
}

const mutations = {
    updatemedienItem (state, qty) {
        state.medienitems = qty
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
